import React from 'react';
import { SvgIcon } from '@mui/material';

const SvgGlobalReach = (props) => (
  <SvgIcon {...props} title="Global reach" viewBox="4 4 22 22">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      zoomAndPan="magnify"
      viewBox="0 0 135 135.000003"
      height="30"
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
    >
      <defs>
        <clipPath id="75a23449bf">
          <path
            d="M 66 23.335938 L 69 23.335938 L 69 41 L 66 41 Z M 66 23.335938 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="7907e49f36">
          <path
            d="M 60 23.335938 L 69 23.335938 L 69 33 L 60 33 Z M 60 23.335938 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="3b89f5f1fd">
          <path
            d="M 66 23.335938 L 75 23.335938 L 75 33 L 66 33 Z M 66 23.335938 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="68e1c0116d">
          <path
            d="M 66 93 L 69 93 L 69 110.441406 L 66 110.441406 Z M 66 93 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="6a94fb2593">
          <path
            d="M 66 101 L 75 101 L 75 110.441406 L 66 110.441406 Z M 66 101 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="280572ea77">
          <path
            d="M 60 101 L 69 101 L 69 110.441406 L 60 110.441406 Z M 60 101 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="7ce6f9c2f2">
          <path
            d="M 93 65 L 110.9375 65 L 110.9375 69 L 93 69 Z M 93 65 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="38b46e7181">
          <path
            d="M 102 59 L 110.9375 59 L 110.9375 69 L 102 69 Z M 102 59 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="2f10a68c13">
          <path
            d="M 102 65 L 110.9375 65 L 110.9375 75 L 102 75 Z M 102 65 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="d56f696ae8">
          <path
            d="M 23.832031 65 L 42 65 L 42 69 L 23.832031 69 Z M 23.832031 65 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="bdc410b700">
          <path
            d="M 23.832031 65 L 33 65 L 33 75 L 23.832031 75 Z M 23.832031 65 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="37d38d60e7">
          <path
            d="M 23.832031 59 L 33 59 L 33 69 L 23.832031 69 Z M 23.832031 59 "
            clipRule="nonzero"
          />
        </clipPath>
      </defs>
      <path
        fill="#017163"
        d="M 89.253906 68.523438 L 45.738281 68.523438 C 44.9375 68.523438 44.285156 67.875 44.285156 67.070312 C 44.285156 66.269531 44.9375 65.621094 45.738281 65.621094 L 89.253906 65.621094 C 90.054688 65.621094 90.703125 66.269531 90.703125 67.070312 C 90.703125 67.875 90.054688 68.523438 89.253906 68.523438 Z M 89.253906 68.523438 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 67.496094 90.28125 C 61.296875 90.28125 55.46875 87.867188 51.082031 83.480469 C 46.699219 79.101562 44.285156 73.269531 44.285156 67.070312 C 44.285156 60.875 46.699219 55.042969 51.082031 50.660156 C 55.46875 46.277344 61.296875 43.863281 67.496094 43.863281 C 73.695312 43.863281 79.523438 46.277344 83.90625 50.660156 C 88.289062 55.042969 90.703125 60.875 90.703125 67.070312 C 90.703125 73.269531 88.289062 79.101562 83.90625 83.480469 C 79.523438 87.867188 73.695312 90.28125 67.496094 90.28125 Z M 67.496094 46.761719 C 62.070312 46.761719 56.972656 48.875 53.132812 52.710938 C 49.300781 56.546875 47.1875 61.648438 47.1875 67.070312 C 47.1875 72.496094 49.300781 77.597656 53.132812 81.429688 C 56.972656 85.269531 62.070312 87.378906 67.496094 87.378906 C 72.917969 87.378906 78.019531 85.269531 81.855469 81.429688 C 85.691406 77.597656 87.804688 72.496094 87.804688 67.070312 C 87.804688 61.648438 85.691406 56.546875 81.855469 52.710938 C 78.019531 48.875 72.917969 46.761719 67.496094 46.761719 Z M 67.496094 46.761719 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 67.496094 90.28125 C 61.296875 90.28125 55.46875 87.867188 51.082031 83.480469 C 50.695312 83.09375 50.328125 82.691406 49.976562 82.285156 C 49.65625 81.921875 49.542969 81.421875 49.667969 80.953125 C 49.796875 80.488281 50.144531 80.113281 50.605469 79.957031 C 53.625 78.9375 59.835938 77.226562 67.496094 77.226562 C 75.152344 77.226562 81.367188 78.9375 84.386719 79.960938 C 84.84375 80.113281 85.195312 80.488281 85.320312 80.957031 C 85.449219 81.425781 85.332031 81.925781 85.015625 82.289062 C 84.660156 82.695312 84.292969 83.097656 83.90625 83.484375 C 79.523438 87.867188 73.695312 90.28125 67.496094 90.28125 Z M 53.753906 82.027344 C 57.507812 85.484375 62.359375 87.378906 67.496094 87.378906 C 72.632812 87.378906 77.480469 85.484375 81.238281 82.023438 C 78.042969 81.128906 73.195312 80.128906 67.496094 80.128906 C 61.796875 80.128906 56.949219 81.128906 53.753906 82.027344 Z M 53.753906 82.027344 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 67.496094 56.917969 C 59.835938 56.917969 53.625 55.203125 50.605469 54.183594 C 50.144531 54.03125 49.796875 53.65625 49.667969 53.1875 C 49.542969 52.722656 49.65625 52.21875 49.976562 51.855469 C 50.332031 51.449219 50.695312 51.046875 51.082031 50.660156 C 55.46875 46.277344 61.296875 43.863281 67.496094 43.863281 C 73.695312 43.863281 79.523438 46.277344 83.90625 50.660156 C 84.292969 51.050781 84.660156 51.449219 85.015625 51.855469 C 85.332031 52.21875 85.449219 52.722656 85.320312 53.1875 C 85.195312 53.65625 84.84375 54.03125 84.386719 54.183594 C 81.367188 55.203125 75.152344 56.917969 67.496094 56.917969 Z M 53.753906 52.117188 C 56.949219 53.015625 61.796875 54.015625 67.496094 54.015625 C 73.195312 54.015625 78.042969 53.015625 81.238281 52.117188 C 77.480469 48.660156 72.632812 46.761719 67.496094 46.761719 C 62.359375 46.761719 57.507812 48.660156 53.753906 52.117188 Z M 53.753906 52.117188 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 67.496094 90.28125 C 67.253906 90.28125 67.015625 90.222656 66.792969 90.101562 C 66.332031 89.847656 66.046875 89.359375 66.046875 88.832031 L 66.046875 45.320312 C 66.046875 44.792969 66.332031 44.304688 66.792969 44.050781 C 67.257812 43.792969 67.820312 43.8125 68.269531 44.09375 C 69.804688 45.0625 71.222656 46.226562 72.859375 47.863281 C 78.078125 53.082031 80.953125 59.90625 80.953125 67.070312 C 80.953125 74.238281 78.078125 81.0625 72.859375 86.28125 C 71.207031 87.929688 69.792969 89.09375 68.269531 90.058594 C 68.035156 90.207031 67.765625 90.28125 67.496094 90.28125 Z M 68.945312 48.1875 L 68.945312 85.957031 C 69.539062 85.457031 70.148438 84.886719 70.808594 84.230469 C 75.476562 79.558594 78.050781 73.464844 78.050781 67.074219 C 78.050781 60.679688 75.476562 54.589844 70.808594 49.914062 C 70.152344 49.261719 69.539062 48.691406 68.945312 48.1875 Z M 68.945312 48.1875 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 67.496094 90.273438 C 67.226562 90.273438 66.957031 90.199219 66.722656 90.050781 C 65.183594 89.082031 63.769531 87.917969 62.132812 86.28125 C 56.914062 81.0625 54.039062 74.238281 54.039062 67.070312 C 54.039062 59.90625 56.914062 53.082031 62.132812 47.863281 C 63.769531 46.226562 65.183594 45.0625 66.722656 44.09375 C 67.167969 43.8125 67.734375 43.792969 68.195312 44.050781 C 68.660156 44.304688 68.945312 44.792969 68.945312 45.320312 L 68.945312 88.824219 C 68.945312 89.351562 68.660156 89.839844 68.195312 90.09375 C 67.976562 90.214844 67.738281 90.273438 67.496094 90.273438 Z M 66.046875 48.1875 C 65.449219 48.691406 64.839844 49.257812 64.183594 49.914062 C 59.515625 54.585938 56.941406 60.675781 56.941406 67.070312 C 56.941406 73.464844 59.515625 79.554688 64.183594 84.226562 C 64.839844 84.882812 65.449219 85.449219 66.046875 85.953125 Z M 66.046875 48.1875 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <g clipPath="url(#75a23449bf)">
        <path
          fill="#017163"
          d="M 67.496094 40.960938 C 66.695312 40.960938 66.046875 40.3125 66.046875 39.511719 L 66.046875 25.003906 C 66.046875 24.203125 66.695312 23.554688 67.496094 23.554688 C 68.296875 23.554688 68.945312 24.203125 68.945312 25.003906 L 68.945312 39.511719 C 68.945312 40.3125 68.296875 40.960938 67.496094 40.960938 Z M 67.496094 40.960938 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#7907e49f36)">
        <path
          fill="#017163"
          d="M 61.691406 32.257812 C 61.320312 32.257812 60.949219 32.117188 60.667969 31.832031 C 60.101562 31.265625 60.101562 30.347656 60.667969 29.78125 L 66.46875 23.980469 C 67.035156 23.410156 67.957031 23.410156 68.519531 23.980469 C 69.089844 24.546875 69.089844 25.464844 68.519531 26.03125 L 62.71875 31.832031 C 62.4375 32.117188 62.066406 32.257812 61.691406 32.257812 Z M 61.691406 32.257812 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#3b89f5f1fd)">
        <path
          fill="#017163"
          d="M 73.296875 32.257812 C 72.925781 32.257812 72.554688 32.117188 72.273438 31.832031 L 66.46875 26.03125 C 65.902344 25.464844 65.902344 24.546875 66.46875 23.980469 C 67.035156 23.410156 67.957031 23.410156 68.519531 23.980469 L 74.324219 29.78125 C 74.890625 30.347656 74.890625 31.265625 74.324219 31.832031 C 74.039062 32.117188 73.667969 32.257812 73.296875 32.257812 Z M 73.296875 32.257812 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#68e1c0116d)">
        <path
          fill="#017163"
          d="M 67.496094 110.589844 C 66.695312 110.589844 66.046875 109.941406 66.046875 109.140625 L 66.046875 94.632812 C 66.046875 93.832031 66.695312 93.183594 67.496094 93.183594 C 68.296875 93.183594 68.945312 93.832031 68.945312 94.632812 L 68.945312 109.140625 C 68.945312 109.941406 68.296875 110.589844 67.496094 110.589844 Z M 67.496094 110.589844 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#6a94fb2593)">
        <path
          fill="#017163"
          d="M 67.496094 110.589844 C 67.125 110.589844 66.753906 110.449219 66.46875 110.164062 C 65.902344 109.597656 65.902344 108.679688 66.46875 108.113281 L 72.273438 102.3125 C 72.839844 101.742188 73.757812 101.742188 74.324219 102.3125 C 74.890625 102.878906 74.890625 103.796875 74.324219 104.363281 L 68.519531 110.164062 C 68.238281 110.449219 67.867188 110.589844 67.496094 110.589844 Z M 67.496094 110.589844 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#280572ea77)">
        <path
          fill="#017163"
          d="M 67.496094 110.589844 C 67.125 110.589844 66.753906 110.449219 66.46875 110.164062 L 60.667969 104.363281 C 60.101562 103.796875 60.101562 102.878906 60.667969 102.3125 C 61.234375 101.742188 62.152344 101.742188 62.71875 102.3125 L 68.519531 108.113281 C 69.089844 108.679688 69.089844 109.597656 68.519531 110.164062 C 68.238281 110.449219 67.867188 110.589844 67.496094 110.589844 Z M 67.496094 110.589844 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#7ce6f9c2f2)">
        <path
          fill="#017163"
          d="M 109.5625 68.523438 L 95.058594 68.523438 C 94.257812 68.523438 93.605469 67.875 93.605469 67.070312 C 93.605469 66.269531 94.257812 65.621094 95.058594 65.621094 L 109.5625 65.621094 C 110.363281 65.621094 111.011719 66.269531 111.011719 67.070312 C 111.011719 67.875 110.363281 68.523438 109.5625 68.523438 Z M 109.5625 68.523438 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#38b46e7181)">
        <path
          fill="#017163"
          d="M 109.5625 68.523438 C 109.191406 68.523438 108.820312 68.378906 108.539062 68.097656 L 102.734375 62.296875 C 102.167969 61.726562 102.167969 60.8125 102.734375 60.242188 C 103.300781 59.675781 104.21875 59.675781 104.785156 60.242188 L 110.589844 66.046875 C 111.15625 66.613281 111.15625 67.53125 110.589844 68.097656 C 110.304688 68.378906 109.933594 68.523438 109.5625 68.523438 Z M 109.5625 68.523438 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#2f10a68c13)">
        <path
          fill="#017163"
          d="M 103.761719 74.324219 C 103.390625 74.324219 103.019531 74.183594 102.734375 73.898438 C 102.167969 73.332031 102.167969 72.414062 102.734375 71.847656 L 108.539062 66.046875 C 109.105469 65.480469 110.019531 65.480469 110.589844 66.046875 C 111.15625 66.613281 111.15625 67.53125 110.589844 68.097656 L 104.785156 73.898438 C 104.503906 74.183594 104.132812 74.324219 103.761719 74.324219 Z M 103.761719 74.324219 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#d56f696ae8)">
        <path
          fill="#017163"
          d="M 39.933594 68.523438 L 25.429688 68.523438 C 24.628906 68.523438 23.976562 67.875 23.976562 67.070312 C 23.976562 66.269531 24.628906 65.621094 25.429688 65.621094 L 39.933594 65.621094 C 40.734375 65.621094 41.386719 66.269531 41.386719 67.070312 C 41.386719 67.875 40.734375 68.523438 39.933594 68.523438 Z M 39.933594 68.523438 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#bdc410b700)">
        <path
          fill="#017163"
          d="M 31.230469 74.324219 C 30.859375 74.324219 30.488281 74.183594 30.207031 73.898438 L 24.402344 68.097656 C 23.835938 67.53125 23.835938 66.613281 24.402344 66.046875 C 24.96875 65.480469 25.886719 65.480469 26.453125 66.046875 L 32.257812 71.847656 C 32.824219 72.414062 32.824219 73.332031 32.257812 73.898438 C 31.972656 74.183594 31.601562 74.324219 31.230469 74.324219 Z M 31.230469 74.324219 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <g clipPath="url(#37d38d60e7)">
        <path
          fill="#017163"
          d="M 25.429688 68.523438 C 25.058594 68.523438 24.6875 68.378906 24.402344 68.097656 C 23.835938 67.53125 23.835938 66.613281 24.402344 66.046875 L 30.207031 60.242188 C 30.769531 59.675781 31.691406 59.675781 32.257812 60.242188 C 32.824219 60.8125 32.824219 61.726562 32.257812 62.296875 L 26.453125 68.097656 C 26.171875 68.378906 25.800781 68.523438 25.429688 68.523438 Z M 25.429688 68.523438 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
      <path
        fill="#017163"
        d="M 47.1875 48.214844 C 46.816406 48.214844 46.445312 48.070312 46.160156 47.789062 L 36.007812 37.636719 C 35.441406 37.066406 35.441406 36.152344 36.007812 35.582031 C 36.574219 35.015625 37.492188 35.015625 38.058594 35.582031 L 48.210938 45.738281 C 48.78125 46.304688 48.78125 47.222656 48.210938 47.789062 C 47.929688 48.070312 47.558594 48.214844 47.1875 48.214844 Z M 47.1875 48.214844 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 37.03125 46.761719 C 36.230469 46.761719 35.582031 46.113281 35.582031 45.3125 L 35.582031 36.609375 C 35.582031 35.808594 36.230469 35.160156 37.03125 35.160156 C 37.832031 35.160156 38.484375 35.808594 38.484375 36.609375 L 38.484375 45.3125 C 38.484375 46.113281 37.832031 46.761719 37.03125 46.761719 Z M 37.03125 46.761719 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 45.738281 38.058594 L 37.03125 38.058594 C 36.230469 38.058594 35.582031 37.410156 35.582031 36.609375 C 35.582031 35.808594 36.230469 35.160156 37.03125 35.160156 L 45.738281 35.160156 C 46.539062 35.160156 47.1875 35.808594 47.1875 36.609375 C 47.1875 37.410156 46.539062 38.058594 45.738281 38.058594 Z M 45.738281 38.058594 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 97.957031 98.984375 C 97.585938 98.984375 97.214844 98.84375 96.933594 98.558594 L 86.777344 88.40625 C 86.210938 87.839844 86.210938 86.921875 86.777344 86.355469 C 87.34375 85.789062 88.261719 85.789062 88.828125 86.355469 L 98.984375 96.507812 C 99.550781 97.074219 99.550781 97.992188 98.984375 98.558594 C 98.699219 98.84375 98.328125 98.984375 97.957031 98.984375 Z M 97.957031 98.984375 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 97.957031 98.984375 C 97.15625 98.984375 96.507812 98.335938 96.507812 97.535156 L 96.507812 88.832031 C 96.507812 88.027344 97.15625 87.378906 97.957031 87.378906 C 98.757812 87.378906 99.410156 88.027344 99.410156 88.832031 L 99.410156 97.535156 C 99.410156 98.335938 98.757812 98.984375 97.957031 98.984375 Z M 97.957031 98.984375 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 97.957031 98.984375 L 89.253906 98.984375 C 88.453125 98.984375 87.804688 98.335938 87.804688 97.535156 C 87.804688 96.730469 88.453125 96.082031 89.253906 96.082031 L 97.957031 96.082031 C 98.757812 96.082031 99.410156 96.730469 99.410156 97.535156 C 99.410156 98.335938 98.757812 98.984375 97.957031 98.984375 Z M 97.957031 98.984375 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 87.804688 48.214844 C 87.433594 48.214844 87.0625 48.070312 86.777344 47.789062 C 86.210938 47.222656 86.210938 46.304688 86.777344 45.738281 L 96.933594 35.582031 C 97.5 35.015625 98.417969 35.015625 98.984375 35.582031 C 99.550781 36.152344 99.550781 37.066406 98.984375 37.636719 L 88.828125 47.789062 C 88.546875 48.070312 88.175781 48.214844 87.804688 48.214844 Z M 87.804688 48.214844 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 97.957031 38.058594 L 89.253906 38.058594 C 88.453125 38.058594 87.804688 37.410156 87.804688 36.609375 C 87.804688 35.808594 88.453125 35.160156 89.253906 35.160156 L 97.957031 35.160156 C 98.757812 35.160156 99.410156 35.808594 99.410156 36.609375 C 99.410156 37.410156 98.757812 38.058594 97.957031 38.058594 Z M 97.957031 38.058594 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 97.957031 46.761719 C 97.15625 46.761719 96.507812 46.113281 96.507812 45.3125 L 96.507812 36.609375 C 96.507812 35.808594 97.15625 35.160156 97.957031 35.160156 C 98.757812 35.160156 99.410156 35.808594 99.410156 36.609375 L 99.410156 45.3125 C 99.410156 46.113281 98.757812 46.761719 97.957031 46.761719 Z M 97.957031 46.761719 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 37.03125 98.984375 C 36.660156 98.984375 36.289062 98.84375 36.007812 98.558594 C 35.441406 97.992188 35.441406 97.074219 36.007812 96.507812 L 46.160156 86.355469 C 46.726562 85.789062 47.648438 85.789062 48.210938 86.355469 C 48.78125 86.921875 48.78125 87.839844 48.210938 88.40625 L 38.058594 98.558594 C 37.777344 98.84375 37.40625 98.984375 37.03125 98.984375 Z M 37.03125 98.984375 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 45.738281 98.984375 L 37.03125 98.984375 C 36.230469 98.984375 35.582031 98.335938 35.582031 97.535156 C 35.582031 96.730469 36.230469 96.082031 37.03125 96.082031 L 45.738281 96.082031 C 46.539062 96.082031 47.1875 96.730469 47.1875 97.535156 C 47.1875 98.335938 46.539062 98.984375 45.738281 98.984375 Z M 45.738281 98.984375 "
        fillOpacity="1"
        fillRule="nonzero"
      />
      <path
        fill="#017163"
        d="M 37.03125 98.984375 C 36.230469 98.984375 35.582031 98.335938 35.582031 97.535156 L 35.582031 88.832031 C 35.582031 88.027344 36.230469 87.378906 37.03125 87.378906 C 37.832031 87.378906 38.484375 88.027344 38.484375 88.832031 L 38.484375 97.535156 C 38.484375 98.335938 37.832031 98.984375 37.03125 98.984375 Z M 37.03125 98.984375 "
        fillOpacity="1"
        fillRule="nonzero"
      />
    </svg>
  </SvgIcon>
);

export default SvgGlobalReach;
